namespace GeniuzPOS.ReportMasterData {
    export interface Report_1502_NForm {
        Year: Serenity.LookupEditor;
        SubCat1Code: Serenity.StringEditor;
        SubCat1Name: Serenity.StringEditor;
    }

    export class Report_1502_NForm extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1502_N';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1502_NForm.init)  {
                Report_1502_NForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(Report_1502_NForm, [
                    'Year', w0,
                    'SubCat1Code', w1,
                    'SubCat1Name', w1
                ]);
            }
        }
    }
}
